export default function FloatingButton() {
  return (
    <div className="fixed right-0 top-1/2 transform -translate-y-1/2">
      <div className="bg-blue-600 text-white px-4 py-6 rotate-90 rounded-t-lg cursor-pointer">
        Book A Demo
      </div>
    </div>
  );
}
